import { AppLogoSmall, AppLogoUSA } from 'components/_common/Icons';
import AboutIconSvg from 'components/_common/Icons/SVGIcons/AboutIconSvg';
import ApplePaySvg from 'components/_common/Icons/SVGIcons/ApplePaySvg';
import ArrowLineSvg from 'components/_common/Icons/SVGIcons/ArrowLineSvg';
import BlogIconSvg from 'components/_common/Icons/SVGIcons/BlogIconSvg';
import ContactIconSvg from 'components/_common/Icons/SVGIcons/ContactIconSvg';
import DiscoverSvg from 'components/_common/Icons/SVGIcons/DiscoverSvg';
import FacebookSvg from 'components/_common/Icons/SVGIcons/FacebookSvg';
import FindFFLIconSvg from 'components/_common/Icons/SVGIcons/FindFFLIconSvg';
import GooglePaySvg from 'components/_common/Icons/SVGIcons/GooglePaySvg';
import GunIconSvg from 'components/_common/Icons/SVGIcons/GunIconSvg';
import InfoCircleIconSvg from 'components/_common/Icons/SVGIcons/InfoCircleIconSvg';
import InfoCircleOutlineSvg from 'components/_common/Icons/SVGIcons/InfoCircleOutlineSvg';
import InstagramSvg from 'components/_common/Icons/SVGIcons/InstagramSvg';
import MastercardSvg from 'components/_common/Icons/SVGIcons/MastercardSvg';
import MessageSvg from 'components/_common/Icons/SVGIcons/MessageSvg';
import PartnerIconSvg from 'components/_common/Icons/SVGIcons/PartnerIconSvg';
import ReviewIconSvg from 'components/_common/Icons/SVGIcons/ReviewIconSvg';
import RumbleSvg from 'components/_common/Icons/SVGIcons/RumbleSvg';
import ShipCartSvg from 'components/_common/Icons/SVGIcons/ShipCartSvg';
import TruckSvg from 'components/_common/Icons/SVGIcons/TruckSvg';
import TwitterSvg from 'components/_common/Icons/SVGIcons/TwitterSvg';
import UserAddSvg from 'components/_common/Icons/SVGIcons/UserAddSvg';
import UsersIconSvg from 'components/_common/Icons/SVGIcons/UsersIconSvg';
import UserSquareOutlinedSvg from 'components/_common/Icons/SVGIcons/UserSquareOutlinedSvg';
import UserSvg from 'components/_common/Icons/SVGIcons/UserSvg';
import VisaSvg from 'components/_common/Icons/SVGIcons/VisaSvg';
import YouTubeSvg from 'components/_common/Icons/SVGIcons/YouTubeSvg';
import { CUSTOMER_ROLE_SLUG, FFL_ROLE_SLUG } from 'config/app.config';
import { pluck } from 'helpers/ArrayHelper';
import { placeParamsToURL } from 'helpers/CommonHelper';
import { MARKETPLACE_SLUG } from 'helpers/DataHelper';
import { getCurrentDateTime } from 'helpers/DateHelper';
import { comingSoonAlert } from 'helpers/SwalAlertHelper';
import { t } from 'i18next';
import AddReviewModal from 'modules/customer/components/_common/ModuleSections/CustomerReviews/Modals/AddReviewModal';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { loginRoutes } from 'routes/admin/AdminRoutes';
import { customerMainRoutes, getCustomerContentPageRoute } from 'routes/customer/CustomerRoutes';
import {
  userCurrentRoleSlugSelector,
  userProfileInfoSelector,
} from 'store/auth/selectors/authSelectors';
import { getCustomerReviewCounter } from 'store/customer/actions/CustomerReviewAction';
import {
  megaMenuCategoriesSelector,
  paymentTypesSelector,
  socialMediaUrlsSelector,
  supportEmailSelector,
} from 'store/customer/selectors/CustomerGlobalSelectors';
import { useAppSelector } from 'store/hooks';
import { PRODUCT_FILTER_QUERY_KEYS } from 'utils/productQuery';

export default function Footer() {
  const currentRoleSlug = useAppSelector(userCurrentRoleSlugSelector);
  const userProfileInfo = useAppSelector(userProfileInfoSelector);
  // Guests see both prompts. A logged-in customer only sees the FFL prompt (and vice
  // versa) - no point telling someone to create the account they already have. Admin
  // accounts match neither slug, so both stay visible for them too.
  const showCustomerAuthLinks = currentRoleSlug !== CUSTOMER_ROLE_SLUG;
  const showFflAuthLinks = currentRoleSlug !== FFL_ROLE_SLUG;
  const socialMediaUrls = useAppSelector(socialMediaUrlsSelector);
  const allCategories = useAppSelector(megaMenuCategoriesSelector);
  // only featured categories are listed in the footer
  const categoryData = allCategories.filter((item: any) => item.is_featured);
  const supportEmail = useAppSelector(supportEmailSelector);
  const paymentTypesArr = useAppSelector(paymentTypesSelector);
  const paymentTypes = useMemo(() => {
    return pluck(paymentTypesArr as any, 'name');
  }, [paymentTypesArr]);

  // One marketplace review per account - same flag drives the Customer and FFL
  // columns since a logged-in user only ever occupies one of those roles at a time.
  const [hasReviewed, setHasReviewed] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);

  useEffect(() => {
    if (!userProfileInfo) return;
    (async () => {
      const response: any = await getCustomerReviewCounter();
      if (response?.status && response?.data?.tabs?.marketplace > 0) {
        setHasReviewed(true);
      }
    })();
  }, [userProfileInfo]);
  return (
    <footer className="app-footer">
      {/* Top Newsletter Section */}
      <div className="newsletter-section d-flex align-items-center">
        {/* container-fluid w-100 px-md-5 px-4 d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-between gap-3 py-4 py-lg-0 */}
        <div className="container d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-between gap-3 py-4 py-lg-0 me-auto mx-md-0">
          <div className="d-flex align-items-center justify-content-center align-items-md-center justify-content-md-center gap-3 text-white">
            <span>
              <MessageSvg width={24} height={24} />
            </span>
            <div className="text-start">
              <h6 className="mb-0">Stay in the Know</h6>
              <small>Get the latest updates and exclusive offers</small>
            </div>
          </div>

          <div className="newsletter-form d-flex align-items-center gap-2 w-100 w-lg-auto">
            <input type="text" className="form-control" placeholder="Your Email" />
            <button className="btn ">Sign Up</button>
          </div>

          <div className="social-icons d-flex justify-content-center gap-2">
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={socialMediaUrls?.mlgs_youtube_url ?? '#'}
              >
                <YouTubeSvg width={20} height={20} />
              </a>
            </span>
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={socialMediaUrls?.mlgs_x_url ?? '#'}
              >
                <TwitterSvg width={20} height={20} />
              </a>
            </span>
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={socialMediaUrls?.mlgs_instagram_url ?? '#'}
              >
                <InstagramSvg width={20} height={20} />
              </a>
            </span>
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={socialMediaUrls?.mlgs_facebook_url ?? '#'}
              >
                <FacebookSvg width={20} height={20} />
              </a>
            </span>
            <span>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={socialMediaUrls?.mlgs_rumble_url ?? '#'}
              >
                <RumbleSvg width={20} height={20} />
              </a>
            </span>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      {/* footer-links container-fluid px-md-5 px-4 */}
      <div className="footer-links container px-3 px-lg-3 px-xxl-0">
        <div className="row mx-0 justify-content-between">
          {/* Quick Actions */}
          <div className="col-12 col-md-12 col-lg-3 col-xl-3 mb-4 mb-md-3 footer-description px-0">
            {/* <h6>QUICK ACTIONS</h6> */}
            <div className="d-flex align-items-center gap-2 mb-3">
              <img src={AppLogoSmall} alt="Logo" style={{ height: '36px', width: 'auto' }} />
              <h6 className="m-0">About Us</h6>
            </div>
            <div className="col-12 footer-action">
              <span className="footer-action-text mb-2">
                My Local Gun Shop (MLGS) is a secure and easy-to-use online marketplace connecting
                firearm buyers with verified Federal Firearms License (FFL) dealers across the
                United States. From handguns and rifles to optics and accessories, MLGS customers
                shop confidently with listings from trusted gun stores across the nation. Committed
                to customer satisfaction and privacy, MLGS does not require customers to create an
                account and does not take a transaction fee on sales.
              </span>
            </div>

            <div className="col-12 footer-action mt-3">
              <span className="footer-action-text mb-2">
                Whether you are a first-time buyer or a seasoned firearms enthusiast, our platform
                is built to simplify the buying process while supporting responsible firearm
                ownership and local gun shops.
              </span>
            </div>

            <div className="payment-logos d-flex gap-2 mt-3">
              {paymentTypes.includes('card') && (
                <>
                  <VisaSvg />
                  <DiscoverSvg />
                  <MastercardSvg />
                </>
              )}
              {paymentTypes.includes('ApplePay') && <ApplePaySvg />}
              {paymentTypes.includes('Gpay') && <GooglePaySvg />}
            </div>

            {/* <div className="quick-card">
              <span>
                <img src={CustomerLocation} alt="CustomerYoutube" />
              </span>
              Gun Shop Locator
            </div>
            <div className="quick-card">
              <span>
                <img src={CustomerCart} alt="CustomerYoutube" />
              </span>
              How to Buy a Gun Online
            </div>
            <div className="quick-card">
              <span>
                <img src={CustomerTime} alt="CustomerYoutube" />
              </span>
              Sell Your Firearm(s)
            </div> */}
          </div>

          {/* Shop */}
          <div className="col-12 col-md-6 col-lg-auto col-xl-auto links-column">
            <h6 className="mb-3 category-head">{t('shop')}</h6>
            <ul>
              {categoryData.map((item: any) => (
                <li key={item.id}>
                  <Link
                    to={`${placeParamsToURL(customerMainRoutes.productList.path)}?${PRODUCT_FILTER_QUERY_KEYS.CATEGORY}=${item.slug}`}
                    className="category-link"
                  >
                    <span className="arrow-icon">
                      <ArrowLineSvg />
                    </span>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="col-12 col-md-6 col-lg-auto col-xl-auto links-column">
            <h6 className="mb-3 category-head">{t('company')}</h6>
            <ul>
              <li>
                <Link to={placeParamsToURL(customerMainRoutes.blogList.path)}>
                  <BlogIconSvg />
                  {t('blog')}
                </Link>
              </li>
              <li>
                <a>
                  <AboutIconSvg />
                  {t('about')}
                </a>
              </li>
              <li>
                <a>
                  <ContactIconSvg />
                  {t('contact')}
                </a>
              </li>
              <li>
                <a>
                  <PartnerIconSvg />
                  {t('partners')}
                </a>
              </li>
              <li>
                <a>
                  <ShipCartSvg stroke="currentColor" />
                  {t('how_to_buy')}
                </a>
              </li>
            </ul>

            <h6 className="mb-3 category-head mt-4 mt-md-0">{t('support')}</h6>
            <ul>
              <li>
                <a>
                  <ContactIconSvg />
                  {t('contact_us')}
                </a>
              </li>
              <li>
                <Link to={placeParamsToURL(customerMainRoutes.faq.path)}>
                  <InfoCircleIconSvg />
                  {t('faq')}
                </Link>
              </li>
            </ul>
          </div>
          {/* Customer */}
          <div className="col-12 col-md-6 col-lg-auto col-xl-auto links-column">
            <h6 className="mb-3 category-head">{t('customer')}</h6>
            <ul>
              <li>
                <Link to={placeParamsToURL(customerMainRoutes.sellFirearms.path)}>
                  {/* <img src={CustomerGmail} alt="CustomerGmail" className="icon-img" /> */}
                  <GunIconSvg />
                  {t('firearm_trade_in')}
                </Link>
              </li>
              <li>
                <Link to={customerMainRoutes.fflListing.path}>
                  <FindFFLIconSvg /> {t('find_an_ffl')}
                </Link>
              </li>
              {showCustomerAuthLinks ? (
                <>
                  <li>
                    <Link to={placeParamsToURL(loginRoutes.login.path)}>
                      <UserSvg />
                      {t('login')}
                    </Link>
                  </li>
                  <li>
                    <Link to={placeParamsToURL(loginRoutes.customerSignup.path)}>
                      <UserAddSvg />
                      {t('create_account')}
                    </Link>
                  </li>
                </>
              ) : (
                !hasReviewed && (
                  <li>
                    <a onClick={() => setIsReviewModalOpen(true)} style={{ cursor: 'pointer' }}>
                      <ReviewIconSvg />
                      {t('write_a_review', { defaultValue: 'Write a Review' })}
                    </a>
                  </li>
                )
              )}
              <li>
                <a>
                  <TruckSvg fill="currentColor" />
                  {t('track_order')}
                </a>
              </li>
            </ul>
          </div>
          {/* FFL */}
          <div className="col-12 col-md-6 col-lg-auto col-xl-auto links-column">
            <h6 className="mb-3 category-head">{t('ffl')}</h6>
            <ul>
              {showFflAuthLinks ? (
                <>
                  <li>
                    <Link to={placeParamsToURL(loginRoutes.login.path)}>
                      <UserSquareOutlinedSvg />
                      {t('customer_ffl_login')}
                    </Link>
                  </li>
                  <li>
                    <Link to={placeParamsToURL(loginRoutes.signup.path)}>
                      <UserAddSvg />
                      {t('create_account')}
                    </Link>
                  </li>
                </>
              ) : (
                !hasReviewed && (
                  <li>
                    <a onClick={() => setIsReviewModalOpen(true)} style={{ cursor: 'pointer' }}>
                      <ReviewIconSvg />
                      {t('write_a_review', { defaultValue: 'Write a Review' })}
                    </a>
                  </li>
                )
              )}
              <li>
                <a>
                  <UsersIconSvg />
                  {t('join_the_network')}
                </a>
              </li>
              <li>
                <a onClick={() => comingSoonAlert()}>
                  <InfoCircleOutlineSvg />
                  {t('how_to_sell')}
                </a>
              </li>
              <li>
                <a href={`mailto:${supportEmail}`} className="email-support-link">
                  <MessageSvg />
                  {t('email')} <span className="live-link mx-1">&bull;</span>
                  <span className="live-link">{t('live_support_available')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom d-flex align-items-center">
        <div className="container px-md-4 px-4 px-xxl-0  d-flex flex-column flex-lg-row justify-content-center justify-content-lg-between align-items-center gap-3 gap-lg-0">
          <div className="logo">
            <span className="logo-footer">
              <img src={AppLogoUSA} alt="AppLogoSmall" />
            </span>
            <span>MyLocalGunShop</span>
            <sup className="tm-sup-text">TM</sup>
          </div>

          <div className="copy text-center">
            <span>© {getCurrentDateTime('Y')} MyLocalGunShop.com All rights reserved.</span>
          </div>
          <div className="d-flex flex-wrap justify-content-center justify-content-lg-between align-items-center gap-3">
            <div>
              <Link className="links" to={getCustomerContentPageRoute('terms_and_conditions')}>
                Terms and Conditions
              </Link>
            </div>
            <div>
              <span>&bull;</span>
            </div>
            <div>
              <Link className="links" to={getCustomerContentPageRoute('privacy_policy')}>
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      {isReviewModalOpen && (
        <AddReviewModal
          visible={isReviewModalOpen}
          module={MARKETPLACE_SLUG}
          details={null}
          onCancel={() => setIsReviewModalOpen(false)}
          onSubmit={() => {
            setIsReviewModalOpen(false);
            setHasReviewed(true);
          }}
        />
      )}
    </footer>
  );
}
